export default __webpack_public_path__ + "static/media/plane.eba708a4.svg";